import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">
              虚空韩漫网
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              专业的<strong>韩国漫画在线阅读</strong>平台，提供<strong>无遮挡下拉式韩漫</strong>阅读体验。
              海量<strong>韩漫漫画</strong>资源每日更新，简洁沉浸的阅读界面让您完全融入漫画情节。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4 uppercase tracking-wide">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-sm text-background-400 mb-1">联系邮箱</p>
              <a href="mailto:contact@xukonghanman.com" className="text-sm text-background-200 hover:text-primary-400 transition-colors duration-200">
                contact@xukonghanman.com
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 虚空韩漫网. 本站所有漫画内容均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}